module.exports = __webpack_public_path__ + "static/media/food-insecurity-sm.d70a2a22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/food-insecurity-sm.jpg
// module id = 165
// module chunks = 13